/**
 * Auto-generated from shared/schemas/budget_schemas.json
 * DO NOT EDIT - This file is generated by build-schemas.js
 */

// Import JSON schema data
import schemaData from './budget_schemas.json';

export const budgetSchemas = schemaData;
export const definitions = schemaData.definitions;
export const schemas = schemaData.schemas;

// Export individual schema types for convenience
export const hourDataSchema = schemaData.schemas?.hourData;
export const budgetPositionsSchema = schemaData.schemas?.budgetPositions;
export const externalPositionsSchema = schemaData.schemas?.externalPositions;
export const calculationFiguresSchema = schemaData.schemas?.calculationFigures;
export const unitHoursDataSchema = schemaData.schemas?.unitHoursData;
export const billingRatesDataSchema = schemaData.schemas?.billingRatesData;
export const phasesSchema = schemaData.schemas?.phases;
